// src/components/ui/Skeleton.js
import React from "react";

export function Skeleton({ width = "100%", height = 14, radius, style }) {
  return (
    <span
      className="skeleton"
      style={{
        width,
        height,
        borderRadius: radius,
        ...style,
      }}
    />
  );
}

// テーブル読み込み中のプレースホルダ
export function TableSkeleton({ rows = 5, columns = 4 }) {
  const rowKeys = Array.from({ length: rows }, (_, i) => i);
  const colKeys = Array.from({ length: columns }, (_, i) => i);

  return (
    <div className="card" style={{ overflow: "hidden" }}>
      {rowKeys.map((r) => (
        <div
          key={r}
          style={{
            display: "flex",
            gap: 24,
            alignItems: "center",
            padding: "14px 16px",
            borderBottom: "1px solid var(--border)",
          }}
        >
          {colKeys.map((c) => (
            <Skeleton
              key={c}
              width={c === 0 ? "18%" : `${Math.round(60 / columns)}%`}
              height={12}
            />
          ))}
        </div>
      ))}
    </div>
  );
}

export default Skeleton;
